import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
import { dmaBaseCompoundDtoSchema } from "./dma-base-compound.schema";
import { dmaChemicalElementCountDtoSchema } from "./dma-chemical-element-count.schema";
import { dmaPhaseDtoSchema } from "./dma-phase.schema";
import { dmaProteinDtoSchema } from "./dma-protein.schema";
export const dmaCompoundDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    formula: z.string(),
    charge: z.number(),
    molarMass: z.number(),
    phases: z.array(dmaPhaseDtoSchema),
    baseCompounds: z.array(dmaBaseCompoundDtoSchema),
    elementalComposition: z.array(dmaChemicalElementCountDtoSchema),
    protein: z.optional(dmaProteinDtoSchema),
    tags: z.array(z.string()),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
